/**
 * @generated SignedSource<<397cae42da5db66a8907b0661882230e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ThrowOnQueryError$data = {
  readonly extensions: ReadonlyArray<{
    readonly errorType: string | null;
    readonly statusCode: number | null;
  }> | null;
  readonly identifier: string | null;
  readonly message: string | null;
  readonly " $fragmentType": "ThrowOnQueryError";
};
export type ThrowOnQueryError$key = {
  readonly " $data"?: ThrowOnQueryError$data;
  readonly " $fragmentSpreads": FragmentRefs<"ThrowOnQueryError">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ThrowOnQueryError",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "identifier"
    },
    {
      "kind": "ScalarField",
      "name": "message"
    },
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCode"
        },
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ]
    }
  ],
  "type": "QueryError"
};

(node as any).hash = "4b77c5110c5924963681d8cf535568f2";

export default node;
